export default __webpack_public_path__ + "static/media/ic-arrow-next.b3e3808a.svg";